import { string, object, number } from 'yup';
import { checkIsraeliPhone } from '../helpers';

export const customerAssignmentsListSearchValidation = object().shape({
  phoneNumber: string()
    .test('check phone number', 'מספר הפלאפון לא תקין', (value) => {
      return value ? checkIsraeliPhone(value) : false;
    })
    .required('שדה חובה'),
  siteId: number()
    .integer('נא להכניס מספר אתר תקין')
    .positive('נא להכניס מספר אתר תקין'),
  lockerNumber: string().max(16, 'יש להזין עד 16 תווים בלבד'),
});
